import { Directive } from '@angular/core';
import { HostListener, Host, Optional } from '@angular/core';
import { NgModel } from '@angular/forms';
export class TdAutoTrimDirective {
/**
 * @param {?} _model
 */
constructor(
private _model: NgModel) {}
/**
 * Listens to host's (blur) event and trims value.
 * @param {?} event
 * @return {?}
 */
onBlur(event: Event): void {
    if (this._model && this._model.value && typeof(this._model.value) === 'string') {
      this._model.update.emit(this._model.value.trim());
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[tdAutoTrim]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgModel, decorators: [{ type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onBlur': [{ type: HostListener, args: ['blur', ['$event'], ] },],
};
}

function TdAutoTrimDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdAutoTrimDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdAutoTrimDirective.ctorParameters;
/** @type {?} */
TdAutoTrimDirective.propDecorators;
/** @type {?} */
TdAutoTrimDirective.prototype._model;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
